import { IPlayerState } from '../../../State/Player/IPlayerState';
import IPlayerData from '../../IPlayerData';
import { PlayerProperty, Restore, Save } from '../PlayerProperty';

type PlayerStateKey = 'gdprCompliance';
type PlayerDataKeys = 'gdprCompliance';

export default class GDPRCompliance
    implements PlayerProperty<PlayerStateKey, PlayerDataKeys> {
    public restore(playerEndpointData: IPlayerData): Restore<PlayerStateKey> {
        return playerEndpointData.gdprCompliance ? playerEndpointData.gdprCompliance : false;
    }

    public save(playerStateData: IPlayerState): Save<PlayerDataKeys> {
        return {
            gdprCompliance: playerStateData.gdprCompliance,
        };
    }

    public isChanged(
        playerStateData: IPlayerState,
        playerEndpointData: IPlayerData
    ): boolean {
        return (
            playerEndpointData.gdprCompliance !== playerStateData.gdprCompliance
        );
    }
}
